// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f2b70639","239":"81c56fc5","453":"8f1da278","455":"a557a2a2"}[chunkId] + ".chunk.js";
};